import type { Word } from '../../types/word.types';
import WordListItem from './WordListItem';
import WordListItemList from './WordListItemList';

type ViewMode = 'card' | 'list';

interface WordListProps {
  words: Word[];
  onDeleteWord: (wordId: string) => void;
  onRatingChange: (wordId: string, rating: number) => void;
  totalWordsCount?: number;
  viewMode?: ViewMode;
}

function WordList({ words, onDeleteWord, onRatingChange, totalWordsCount = 0, viewMode = 'card' }: WordListProps) {
  if (words.length === 0) {
    const message = totalWordsCount > 0
      ? 'No words matching the filter. Try adjusting your filters.'
      : 'No words yet. Start adding words to build your vocabulary!';

    return (
      <div className="text-center py-16 px-4">
        <div className="max-w-md mx-auto">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
            <svg className="w-8 h-8 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2">
            {totalWordsCount > 0 ? 'No matching words' : 'Start your vocabulary journey'}
          </h3>
          <p className="text-muted-foreground text-sm leading-relaxed">
            {message}
          </p>
        </div>
      </div>
    );
  }

  if (viewMode === 'list') {
    return (
      <div className="space-y-2">
        {words.map((word) => (
          <WordListItemList
            key={word.id}
            word={word}
            onDelete={onDeleteWord}
            onRatingChange={onRatingChange}
          />
        ))}
      </div>
    );
  }

  return (
    <ul className="list-none p-0 m-0 space-y-3">
      {words.map((word) => (
        <WordListItem
          key={word.id}
          word={word}
          onDelete={onDeleteWord}
          onRatingChange={onRatingChange}
        />
      ))}
    </ul>
  );
}

export default WordList;
